module.exports = __webpack_public_path__ + "img/61_8.5a50b0b8.png";